<div class="topbar topbar--{{ theme() }}" #topbar>
  <div class="topbar__inner container">
    <div class="d-none d-xl-flex align-items-center topbar__phone">
      <span class="badge badge--secondary me-2">{{ 'contact:telefoonnummer-prefix' | fromDictionary }}</span>
      <a class="nav-bar-link fw-bolder" [href]="'tel:' + ('contact:telefoonnummer' | fromDictionary)">
        {{ 'contact:telefoonnummer' | fromDictionary }}
      </a>
    </div>

    <ul class="nav-bar-list">
      @for (page of menu(); track page) {
        <li class="nav-bar-list__item d-none d-xl-flex">
          <fstr-link
            [cssClasses]="'nav-bar-link'"
            [button]="{
              text: page.title,
              url: page.url || '',
              queryParams: page.queryParams || null,
              routerLink: page.routerLink || null,
              fragment: page.fragment || null,
            }"
            [routerLinkActive]="'is--active'"
            [routerLinkActiveOptions]="{ exact: page.url === '/' || page.pathMatchExact || false }"
            (click)="closeOverlay.emit()"
            [showText]="false"
          >
            <span>{{ page.title }}</span>
            @if (isExternalLink(page)) {
              <fstr-icon anchor="line-icon-external-link"></fstr-icon>
            }
          </fstr-link>
        </li>

        @if (isHalfway($index + 1) || !menu().length) {
          <li class="nav-bar-list__item nav-list__item--logo">
            <a [routerLink]="'/'" class="topbar__logo" (click)="closeOverlay.emit()">
              <svg class="logo-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 483.74 99.05">
                <path
                  class="cls-1"
                  d="M412.01,64.51h-52.3c.18,8.05,2.15,14.75,5.9,20.12,3.75,5.37,9.32,8.05,16.72,8.05,3.79,0,7.95-.67,12.49-2.01,4.53-1.34,8.41-3.21,11.65-5.62l2.08,4.86c-3.15,2.59-7.47,4.76-12.97,6.52-5.5,1.76-11.45,2.64-17.83,2.64-8.14,0-15.17-1.48-21.09-4.44-5.92-2.96-10.45-7.14-13.6-12.56-3.14-5.41-4.72-11.68-4.72-18.8,0-11.47,3.42-20.32,10.27-26.57,6.84-6.24,16.42-9.36,28.72-9.36,7.68,0,14.13,1.5,19.35,4.51,5.22,3.01,9.09,7.01,11.58,12,2.5,4.99,3.75,10.54,3.75,16.65v4.02ZM393.56,57.71c0-3.42-.53-6.96-1.6-10.61-1.06-3.65-2.8-6.73-5.2-9.22-2.41-2.5-5.55-3.75-9.43-3.75-5.09,0-9.09,2.22-12,6.66-2.91,4.44-4.7,10.08-5.34,16.93h33.57Z"
                />
                <path
                  class="cls-1"
                  d="M119.51,32.53c-4.76-3.47-10.98-5.2-18.66-5.2-5.18,0-9.85,1.04-14.01,3.12-4.16,2.08-7.63,4.79-10.4,8.12-1.76-3.61-4.67-6.38-8.74-8.32-4.07-1.94-8.93-2.91-14.57-2.91-4.53,0-8.72.81-12.55,2.43-3.84,1.62-7.15,3.81-9.92,6.59v-9.3L0,30.1v1.53c3.42,1.2,6.57,2.08,9.43,2.64v63.4h21.23v-54.38c2.59-3.14,5.27-5.46,8.05-6.94,2.77-1.48,5.46-2.22,8.05-2.22,3.61,0,6.4,1.02,8.39,3.05,1.99,2.04,2.98,5.55,2.98,10.54v49.94h20.12v-50.64c0-.83-.09-1.99-.28-3.47,4.81-6.29,9.99-9.43,15.54-9.43,8.05,0,12.07,4.53,12.07,13.6v49.94h21.09v-50.64c0-6.2-2.38-11.03-7.14-14.5Z"
                />
                <path class="cls-1" d="M299.37,92.25v5.41h21.23V0l-30.66,2.91v1.66c2.5.93,5.64,1.8,9.43,2.64v85.04Z" />
                <path
                  class="cls-1"
                  d="M477.08,28.09c-2.31-.51-4.95-.76-7.91-.76-3.88,0-7.51,1.11-10.89,3.33-3.38,2.22-5.94,5.41-7.7,9.57h-.55l-1.8-13.18-28.16,3.19v1.39c3.14,1.2,6.29,2.08,9.43,2.64v63.4h21.09v-44.67c2.31-4.44,5.29-8.02,8.95-10.75,3.65-2.73,7.61-4.09,11.86-4.09,2.96,0,5.78.93,8.46,2.77l3.88-9.99c-2.13-1.39-4.35-2.33-6.66-2.84Z"
                />
                <path
                  class="cls-1"
                  d="M223.91,92.25V27.05l-30.38,3.05v1.53c3.24,1.2,6.33,2.08,9.29,2.64v50.5c-2.77,2.31-5.83,4.14-9.16,5.48-3.33,1.34-6.1,2.01-8.32,2.01-3.88,0-6.91-1.06-9.09-3.19-2.17-2.13-3.26-5.69-3.26-10.68V27.05l-30.52,3.05v1.53c3.14,1.2,6.29,2.08,9.43,2.64v45.5c0,6.1,2.47,10.85,7.42,14.22,4.95,3.38,11.72,5.06,20.32,5.06,4.16,0,8.25-.69,12.28-2.08,4.02-1.39,7.65-3.19,10.89-5.41v6.1h21.09v-5.41Z"
                />
                <path class="cls-1" d="M249.71,92.25v5.41h21.23V0l-30.66,2.91v1.66c2.5.93,5.64,1.8,9.43,2.64v85.04Z" />
              </svg>
            </a>
          </li>
        }
      }
    </ul>

    <nav class="topbar__actions">
      <a class="nav-bar-link d-none d-xl-inline-flex" [href]="'mijn-muller-url' | fromDictionary" target="_blank">
        <fstr-icon anchor="icon-user"></fstr-icon>

        <span>{{ 'mijn-muller-tekst' | fromDictionary }}</span>
      </a>

      <a
        class="button button-icon button--secondary button--xs d-lg-none"
        [href]="'tel:' + ('contact:telefoonnummer' | fromDictionary)"
        (click)="closeOverlay.emit()"
        [class.d-none]="menuActive()"
        (click)="closeOverlay.emit()"
      >
        <fstr-icon anchor="icon-phone"></fstr-icon>
      </a>

      <a
        class="button button-icon button--secondary button--xs d-lg-none"
        [href]="'mijn-muller-url' | fromDictionary"
        [class.d-none]="menuActive()"
        (click)="closeOverlay.emit()"
      >
        <fstr-icon anchor="icon-user"></fstr-icon>
      </a>

      <button
        class="nav-bar-link d-xl-none text-decoration-none"
        [class.is--active]="menuActive()"
        (click)="toggleOverlay.emit()"
        type="button"
      >
        @if (menuActive()) {
          <span>Sluiten</span>
        } @else {
          <span>Menu</span>
        }
        <span class="hamburger pt-1" [class.is--active]="menuActive()">
          <span class="hamburger__lines"></span>
        </span>
      </button>
    </nav>
  </div>
</div>

@if (menuActive()) {
  <nav class="nav-overlay topbar--{{ theme() }}">
    <div class="container nav-overlay__inner">
      <ul class="nav-list">
        @for (page of menu(); track page) {
          <li class="nav-list__item">
            <fstr-link
              [cssClasses]="'nav-link'"
              [button]="{
                text: page.title,
                url: page.url || '',
                queryParams: page.queryParams || null,
                routerLink: page.routerLink || null,
                fragment: page.fragment || null,
              }"
              [routerLinkActive]="'is--active'"
              [routerLinkActiveOptions]="{ exact: page.url === '/' }"
              (click)="closeOverlay.emit()"
              [showText]="false"
            >
              <span>{{ page.title }}</span>
              @if (isExternalLink(page)) {
                <fstr-icon anchor="line-icon-external-link"></fstr-icon>
              }
            </fstr-link>
          </li>
        }

        <li class="nav-list__item">
          <a class="nav-link" [href]="'mijn-muller-url' | fromDictionary" (click)="closeOverlay.emit()">
            <div class="chip chip--xs chip--secondary">
              <fstr-icon anchor="icon-user"></fstr-icon>
            </div>

            <span>{{ 'mijn-muller-tekst' | fromDictionary }}</span>
          </a>
        </li>

        <li class="nav-list__item">
          <a class="button button--secondary" [href]="'tel:' + ('contact:telefoonnummer' | fromDictionary)" (click)="closeOverlay.emit()">
            {{ 'contact:telefoonnummer-prefix' | fromDictionary }}
          </a>
        </li>
      </ul>
    </div>
  </nav>
}
